import type { AppKey } from './notFound.js';

const APP_LABELS: Record<AppKey, string> = {
  'customer-web': 'BeatQ Eats',
  'merchant-console': 'BeatQ Eats Merchant',
  'admin-console': 'BeatQ Eats Admin',
  'business-portal': 'BeatQ Eats Business',
};

export interface NotFoundFallbackProps {
  app: AppKey;
}

export function NotFoundFallback({ app }: NotFoundFallbackProps) {
  return (
    <section data-screen-id="404" data-layout="public" className="p-lg">
      <h1 className="mb-xs">Page not found</h1>
      <p className="m-0 text-body-sm text-muted">{APP_LABELS[app]}</p>
      <p>The page you requested does not exist.</p>
    </section>
  );
}
